import { Calendar } from 'lucide-react'
import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { CONTACT_EMAIL } from './consts'
import { useNavigate } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { Button } from 'src/shared/components/ui'

export const BookMeetingSection = () => {
  const navigate = useNavigate()
  const { t } = useLocalization()

  return (
    <Column
      id="book-meeting"
      className="w-full scroll-mt-24 bg-gradient-to-b from-white via-gray-50 to-gray-100 p-4 rounded-2xl"
    >
      <Column className="mx-auto w-full max-w-2xl">
        <Column className="gap-6 items-center text-center">
          <Column className="gap-0">
            <h2 className="text-3xl font-normal mx-auto text-center !leading-tight md:text-4xl">
              {t(
                'Have a merch project coming up?',
                'Har ni ett merchprojekt på gång?'
              )}
            </h2>

            <p className="text-lg text-center mt-4">
              {t(
                'Start a conversation with the team, or work with us as much as you want.',
                'Starta en konversation med teamet, eller jobba med oss så mycket ni vill.'
              )}
            </p>
          </Column>

          <Button
            size="lg"
            radius="full"
            variant="primaryOrange"
            onClick={() => navigate(`${paths.contact}`)}
            className="button-shadow-new hover:shadow-new-hover hover:scale-105 transition-all duration-200 ease-[cubic-bezier(0.34,1.56,0.64,1)] text-md group"
          >
            <Calendar className="w-5 h-5 mr-2 group-hover:rotate-[-12deg] transition-transform" />
            {t('Talk to the Klayder team', 'Prata med Klayder-teamet')}
          </Button>

          <p className="text-sm text-slate-400 mb-4 md:mb-12">
            <a
              href="#try-sara"
              className="text-blue-500 hover:text-blue-600 transition-colors"
            >
              {t('Try Sara', 'Prova Sara')}
            </a>
            {' · '}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-blue-500 hover:text-blue-600 transition-colors"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
        </Column>
      </Column>
    </Column>
  )
}
